import * as React from 'react'

import { CompanyIdentifier } from '../CompanyIdentifier'
import { useCompanyIdentifier } from './useCompanyIdentifier'

interface CompanyPageTitle {
  title?: React.ReactNode
  allowCustomTitle?: boolean
  contentHeight?: string
}

/**
 * SettingsPage title props for the Dashboard, Leads and Opportunities pages.
 * Renders the company identifier as a custom title, or removes the title row
 * entirely (reclaiming its 46px) when there is nothing to show.
 */
export const useCompanyPageTitle = (): CompanyPageTitle => {
  const identifier = useCompanyIdentifier()

  return identifier
    ? { title: <CompanyIdentifier variant="title" />, allowCustomTitle: true }
    : { title: undefined, contentHeight: '100%' }
}
